var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "setting_header" }, [
    _c(
      "a",
      { staticClass: "setting_header_link", attrs: { href: _vm.mgHref } },
      [
        _c("img", {
          staticClass: "setting_header_logo",
          attrs: { src: require("../assets/img/logo.png"), alt: "MatchinGood" }
        })
      ]
    ),
    _c(
      "a",
      {
        staticClass: "setting_header_link setting_header_text mt-1",
        attrs: { target: "_blank", href: _vm.entryHref }
      },
      [
        _c("span", {
          staticClass: "icon icon_candidate_resource icon_middle icon-size"
        }),
        _c("p", { staticClass: "mt-1 item-font-size" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.commonLabel.ENTRY_SCREEN_LINK) + "\n    "
          )
        ])
      ]
    ),
    _c(
      "a",
      {
        staticClass: "setting_header_link setting_header_text mt-1",
        attrs: { target: "_blank", href: _vm.jobHref }
      },
      [
        _c("span", {
          staticClass: "icon icon_job_offer icon_middle icon-size"
        }),
        _c("p", { staticClass: "mt-1 item-font-size" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.commonLabel.JOB_SEARCH_SCREEN_LINK) +
              "\n    "
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }